<template>
  <div>
    <div v-if="!notEmptyObject(tests)" id="no_tests" class="d-flex align-items-center">
      <div class="container text-center">
        <h4 class="font-weight-bold mb-3">A COMPLIANCE TEST HAS NOT BEEN COMPLETED FOR THIS WORKER</h4>
        <button @click="new_entity_test" class="btn orcaBtn">START TEST</button>
      </div>
    </div>
    <div v-else class="row">
      <div class="col-12">
        <b-card header="Latest Compliance Entity Test" header-tag="h4" body-class="mb-3 pb-2 record_card_body">
          <div class="row mb-4">
            <div class="col-md-9">
              <h3 class="font-weight-bolder bp_color">SELF EMPLOYED BUSINESS ENTITY TEST</h3>
              <h5>Viewing test for : {{ worker.person.first_name }} {{ worker.person.surname }} (Ref - {{ worker.internal_finance_ref }})</h5>
              <h5>Test Expiry : {{ test.test_expiry | formatDate }}</h5>
            </div>
            <div class="col-md-3">
              <div v-if="!check_test_expiry()" class="test_status" :class="checkTest(test)">{{ checkTest(test) }}</div>
              <button v-if="checkTest(test) !== 'Pass'" @click="edit_test" class="btn orcaBtn blueBtn mt-2"><i class="fa fa-vials"></i> &nbsp; Edit Test</button>
              <div v-if="check_test_expiry()">
                  <div class="container text-center">
                    <h4 class="font-weight-bold mb-1 mt-3">Expired Entity Test!</h4>
                    <h6 class="font-weight-bold mb-3 mt-1">Expired on - {{ latest_compliance_test.test_expiry }}</h6>
                    <button @click="new_entity_test" class="btn orcaBtn">UPDATE TEST</button>
                  </div>
              </div>
            </div>
          </div>

          <div class="row">
            <!-- Section 1 - Contract Information -->
            <div class="col-12">
              <b-card header="Section 1 - Contract Information" header-tag="h4" body-class="mb-3 pb-2">
                <!-- Using own limited company -->
                <div class="row">
                  <div class="col-xl-8 mb-2" :class="{ 'testIssue': testIssue('using_own_ltd_company'), 'testFail': testFail('using_own_ltd_company')}">
                    <p class="mb-0">
                      <span class="d-inline-block testIF" v-if="testFail('using_own_ltd_company')">FAIL</span>
                      <span class="d-inline-block testIF" v-if="testIssue('using_own_ltd_company')">ISSUE</span>
                      <span class="d-inline-block testQuestion">Are you using your own limited company (or that of a payroll service) as the trading vehicle to invoice the
                        agency/client for your services?</span>
                    </p>
                  </div>
                  <div class="col-xl-4">
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="using_own_ltd_company" value="Yes" v-model="test.using_own_ltd_company" disabled="disabled">
                      <div class="state p-success-o"><label>Yes</label></div>
                    </div>
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="using_own_ltd_company" value="No" v-model="test.using_own_ltd_company" disabled="disabled">
                      <div class="state p-danger-o"><label>No</label></div>
                    </div>
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="using_own_ltd_company" value="Don't Know" v-model="test.using_own_ltd_company" disabled="disabled">
                      <div class="state p-warning-o"><label>Don't Know</label></div>
                    </div>
                  </div>
                </div>
                <!-- UK Tax payer -->
                <div class="row">
                  <div class="col-xl-8 mb-2" :class="{ 'testIssue': testIssue('uk_tax_payer'), 'testFail': testFail('uk_tax_payer')}">
                    <p class="mb-0">
                      <span class="d-inline-block testIF" v-if="testFail('uk_tax_payer')">FAIL</span>
                      <span class="d-inline-block testIF" v-if="testIssue('uk_tax_payer')">ISSUE</span>
                      <span class="d-inline-block testQuestion">Are you a UK tax payer?</span>
                    </p>
                  </div>
                  <div class="col-xl-4">
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="uk_tax_payer" value="Yes" v-model="test.uk_tax_payer" disabled="disabled">
                      <div class="state p-success-o"><label>Yes</label></div>
                    </div>
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="uk_tax_payer" value="No" v-model="test.uk_tax_payer" disabled="disabled">
                      <div class="state p-danger-o"><label>No</label></div>
                    </div>
                  </div>
                </div>
              </b-card>
            </div>
            <!-- Section 2 - Substitution -->
            <div class="col-12">
              <b-card header="Section 2 - Substitution" header-tag="h4" body-class="mb-3 pb-2">
                <!-- Send Substitution -->
                <div class="row">
                  <div class="col-xl-8 mb-2" :class="{ 'testIssue': testIssue('send_substitution'), 'testFail': testFail('send_substitution')}">
                    <p class="mb-0">
                      <span class="d-inline-block testIF" v-if="testFail('send_substitution')">FAIL</span>
                      <span class="d-inline-block testIF" v-if="testIssue('send_substitution')">ISSUE</span>
                      <span class="d-inline-block testQuestion">Under the terms of your contract can you send another contractor to do the work in your place
                        ("Substitution clause")</span>
                    </p>
                  </div>
                  <div class="col-xl-4">
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="send_substitution" value="Yes" v-model="test.send_substitution" disabled="disabled">
                      <div class="state p-success-o"><label>Yes</label></div>
                    </div>
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="send_substitution" value="No" v-model="test.send_substitution" disabled="disabled">
                      <div class="state p-danger-o"><label>No</label></div>
                    </div>
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="send_substitution" value="Don't Know" v-model="test.send_substitution" disabled="disabled">
                      <div class="state p-warning-o"><label>Don't Know</label></div>
                    </div>
                  </div>
                </div>
              </b-card>
            </div>
            <!-- Section 3 - Control -->
            <div class="col-12">
              <b-card header="Section 3 - Control" header-tag="h4" body-class="mb-3 pb-2">
                <!-- SDC -->
                <div class="row">
                  <div class="col-xl-8 mb-2" :class="{ 'testIssue': testIssue('s_d_c'), 'testFail': testFail('s_d_c')}">
                    <p class="mb-0">
                      <span class="d-inline-block testIF" v-if="testFail('s_d_c')">FAIL</span>
                      <span class="d-inline-block testIF" v-if="testIssue('s_d_c')">ISSUE</span>
                      <span class="d-inline-block testQuestion">In your current role are you subject to supervision, direction and/or control?</span>
                    </p>
                  </div>
                  <div class="col-xl-4">
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="s_d_c" value="Yes" v-model="test.s_d_c" disabled="disabled">
                      <div class="state p-danger-o"><label>Yes</label></div>
                    </div>
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="s_d_c" value="No" v-model="test.s_d_c" disabled="disabled">
                      <div class="state p-success-o"><label>No</label></div>
                    </div>
                  </div>
                </div>
                <!-- Switch Projects -->
                <div class="row">
                  <div class="col-xl-8 mb-2" :class="{ 'testIssue': testIssue('switch_projects'), 'testFail': testFail('switch_projects')}">
                    <p class="mb-0">
                      <span class="d-inline-block testIF" v-if="testFail('switch_projects')">FAIL</span>
                      <span class="d-inline-block testIF" v-if="testIssue('switch_projects')">ISSUE</span>
                      <span class="d-inline-block testQuestion">Does your client switch you between projects throughout the duration of your contract as a client’s priorities and
                        workflow's change?</span>
                    </p>
                  </div>
                  <div class="col-xl-4">
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="switch_projects" value="Yes" v-model="test.switch_projects" disabled="disabled">
                      <div class="state p-danger-o"><label>Yes</label></div>
                    </div>
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="switch_projects" value="No" v-model="test.switch_projects" disabled="disabled">
                      <div class="state p-success-o"><label>No</label></div>
                    </div>
                  </div>
                </div>
                <!-- Named Projects -->
                <div class="row">
                  <div class="col-xl-8 mb-2" :class="{ 'testIssue': testIssue('named_project'), 'testFail': testFail('named_project')}">
                    <p class="mb-0">
                      <span class="d-inline-block testIF" v-if="testFail('named_project')">FAIL</span>
                      <span class="d-inline-block testIF" v-if="testIssue('named_project')">ISSUE</span>
                      <span class="d-inline-block testQuestion">Are you contracted on a particular named project which is also specified in the contract?</span>
                    </p>
                  </div>
                  <div class="col-xl-4">
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="named_project" value="Yes" v-model="test.named_project" disabled="disabled">
                      <div class="state p-success-o"><label>Yes</label></div>
                    </div>
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="named_project" value="No" v-model="test.named_project" disabled="disabled">
                      <div class="state p-danger-o"><label>No</label></div>
                    </div>
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="named_project" value="Don't Know" v-model="test.named_project" disabled="disabled">
                      <div class="state p-warning-o"><label>Don't Know</label></div>
                    </div>
                  </div>
                </div>
                <!-- How work performed -->
                <div class="row">
                  <div class="col-xl-8 mb-2" :class="{ 'testIssue': testIssue('how_work_performed'), 'testFail': testFail('how_work_performed')}">
                    <p class="mb-0">
                      <span class="d-inline-block testIF" v-if="testFail('how_work_performed')">FAIL</span>
                      <span class="d-inline-block testIF" v-if="testIssue('how_work_performed')">ISSUE</span>
                      <span class="d-inline-block testQuestion">Do you, the worker, have the freedom to choose how the work is to be performed?</span>
                    </p>
                  </div>
                  <div class="col-xl-4">
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="how_work_performed" value="Yes" v-model="test.how_work_performed" disabled="disabled">
                      <div class="state p-success-o"><label>Yes</label></div>
                    </div>
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="how_work_performed" value="No" v-model="test.how_work_performed" disabled="disabled">
                      <div class="state p-danger-o"><label>No</label></div>
                    </div>
                  </div>
                </div>
                <!-- Decide Working Hours -->
                <div class="row">
                  <div class="col-xl-8 mb-2" :class="{ 'testIssue': testIssue('decide_working_hours'), 'testFail': testFail('decide_working_hours')}">
                    <p class="mb-0">
                      <span class="d-inline-block testIF" v-if="testFail('decide_working_hours')">FAIL</span>
                      <span class="d-inline-block testIF" v-if="testIssue('decide_working_hours')">ISSUE</span>
                      <span class="d-inline-block testQuestion">Can the end client decide the scheduled working hours?</span>
                    </p>
                  </div>
                  <div class="col-xl-4">
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="decide_working_hours" value="Yes" v-model="test.decide_working_hours" disabled="disabled">
                      <div class="state p-danger-o"><label>Yes, the client decides the working schedule</label></div>
                    </div>
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="decide_working_hours" value="No" v-model="test.decide_working_hours" disabled="disabled">
                      <div class="state p-success-o"><label>No, the worker decide the schedule</label></div>
                    </div>
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="decide_working_hours" value="Partly" v-model="test.decide_working_hours" disabled="disabled">
                      <div class="state p-warning-o"><label>Partly the worker and the end client agree schedule</label></div>
                    </div>
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="decide_working_hours" value="Not applicable" v-model="test.decide_working_hours" disabled="disabled">
                      <div class="state p-success-o"><label>Not applicable, no schedule needed as long as agreed deadlines are met</label></div>
                    </div>
                  </div>
                </div>
              </b-card>
            </div>
            <!-- Section 4 - Mutuality of Obligation -->
            <div class="col-12">
              <b-card header="Section 4 - Mutuality of Obligation" header-tag="h4" body-class="mb-3 pb-2">
                <!-- Notice Period -->
                <div class="row">
                  <div class="col-xl-8 mb-2" :class="{ 'testIssue': testIssue('notice_period'), 'testFail': testFail('notice_period')}">
                    <p class="mb-0">
                      <span class="d-inline-block testIF" v-if="testFail('notice_period')">FAIL</span>
                      <span class="d-inline-block testIF" v-if="testIssue('notice_period')">ISSUE</span>
                      <span class="d-inline-block testQuestion">What notice period does your contract specify your client must give you if they are terminating the contract?</span>
                    </p>
                  </div>
                  <div class="col-xl-4">
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="notice_period" value="No Notice" v-model="test.notice_period" disabled="disabled">
                      <div class="state p-success-o"><label>No Notice</label></div>
                    </div>
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="notice_period" value="7 Days" v-model="test.notice_period" disabled="disabled">
                      <div class="state p-danger-o"><label>7 Days</label></div>
                    </div>
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="notice_period" value="Longer" v-model="test.notice_period" disabled="disabled">
                      <div class="state p-danger-o"><label>14&nbsp;Days / 30&nbsp;Days / 1&nbsp;Month / More&nbsp;than&nbsp;30&nbsp;Days</label></div>
                    </div>
                  </div>
                </div>
                <!-- Offer other work -->
                <div class="row">
                  <div class="col-xl-8 mb-2" :class="{ 'testIssue': testIssue('offer_other_work'), 'testFail': testFail('offer_other_work')}">
                    <p class="mb-0">
                      <span class="d-inline-block testIF" v-if="testFail('offer_other_work')">FAIL</span>
                      <span class="d-inline-block testIF" v-if="testIssue('offer_other_work')">ISSUE</span>
                      <span class="d-inline-block testQuestion">If the current project you are working on is completed early before your contract end date would the client offer
                        you other work which you would feel; obliged to take on?</span>
                    </p>
                  </div>
                  <div class="col-xl-4">
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="offer_other_work" value="Yes" v-model="test.offer_other_work" disabled="disabled">
                      <div class="state p-danger-o"><label>Yes</label></div>
                    </div>
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="offer_other_work" value="No" v-model="test.offer_other_work" disabled="disabled">
                      <div class="state p-success-o"><label>No</label></div>
                    </div>
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="offer_other_work" value="Don't Know" v-model="test.offer_other_work" disabled="disabled">
                      <div class="state p-warning-o"><label>Don't Know</label></div>
                    </div>
                  </div>
                </div>
              </b-card>
            </div>
            <!-- Section 5 - Financial Risk -->
            <div class="col-12">
              <b-card header="Section 5 - Financial Risk" header-tag="h4" body-class="mb-3 pb-2">
                <!-- Correct Errors -->
                <div class="row">
                  <div class="col-xl-8 mb-2" :class="{ 'testIssue': testIssue('correct_errors'), 'testFail': testFail('correct_errors')}">
                    <p class="mb-0">
                      <span class="d-inline-block testIF" v-if="testFail('correct_errors')">FAIL</span>
                      <span class="d-inline-block testIF" v-if="testIssue('correct_errors')">ISSUE</span>
                      <span class="d-inline-block testQuestion">In the event that errors have been discovered in work that you have undertaken. Are you expected to correct these
                        errors without charging additional fees?</span>
                    </p>
                  </div>
                  <div class="col-xl-4">
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="correct_errors" value="Yes" v-model="test.correct_errors" disabled="disabled">
                      <div class="state p-success-o"><label>Yes</label></div>
                    </div>
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="correct_errors" value="No" v-model="test.correct_errors" disabled="disabled">
                      <div class="state p-danger-o"><label>No</label></div>
                    </div>
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="correct_errors" value="Don't Know" v-model="test.correct_errors" disabled="disabled">
                      <div class="state p-warning-o"><label>Don't Know</label></div>
                    </div>
                  </div>
                </div>
                <!-- Last Permanent Employer -->
                <div class="row">
                  <div class="col-xl-8 mb-2" :class="{ 'testIssue': testIssue('last_permanent_employer'), 'testFail': testFail('last_permanent_employer')}">
                    <p class="mb-0">
                      <span class="d-inline-block testIF" v-if="testFail('last_permanent_employer')">FAIL</span>
                      <span class="d-inline-block testIF" v-if="testIssue('last_permanent_employer')">ISSUE</span>
                      <span class="d-inline-block testQuestion">Is your current client your last permanent employer?</span>
                    </p>
                  </div>
                  <div class="col-xl-4">
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="last_permanent_employer" value="Yes" v-model="test.last_permanent_employer" disabled="disabled">
                      <div class="state p-danger-o"><label>Yes</label></div>
                    </div>
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="last_permanent_employer" value="No" v-model="test.last_permanent_employer" disabled="disabled">
                      <div class="state p-success-o"><label>No</label></div>
                    </div>
                  </div>
                </div>
                <!-- Entitlements -->
                <div class="row">
                  <div class="col-12">
                    <p class="font-weight-bold">Are you entitled to or have you received any of the following paid for by the end user;</p>
                  </div>
                  <!-- Sick Pay -->
                  <div class="col-xl-8 mb-2" :class="{ 'testIssue': testIssue('sick_pay'), 'testFail': testFail('sick_pay')}">
                    <p class="mb-0">
                      <span class="d-inline-block testIF" v-if="testFail('sick_pay')">FAIL</span>
                      <span class="d-inline-block testIF" v-if="testIssue('sick_pay')">ISSUE</span>
                      <span class="d-inline-block testQuestion">Sick Pay</span>
                    </p>
                  </div>
                  <div class="col-xl-4">
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="sick_pay" value="Yes" v-model="test.sick_pay" disabled="disabled">
                      <div class="state p-danger-o"><label>Yes</label></div>
                    </div>
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="sick_pay" value="No" v-model="test.sick_pay" disabled="disabled">
                      <div class="state p-success-o"><label>No</label></div>
                    </div>
                  </div>
                  <!-- Holiday Entitlement -->
                  <div class="col-xl-8 mb-2" :class="{ 'testIssue': testIssue('holiday_entitlement'), 'testFail': testFail('holiday_entitlement')}">
                    <p class="mb-0">
                      <span class="d-inline-block testIF" v-if="testFail('holiday_entitlement')">FAIL</span>
                      <span class="d-inline-block testIF" v-if="testIssue('holiday_entitlement')">ISSUE</span>
                      <span class="d-inline-block testQuestion">Holiday Entitlement</span>
                    </p>
                  </div>
                  <div class="col-xl-4">
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="holiday_entitlement" value="Yes" v-model="test.holiday_entitlement" disabled="disabled">
                      <div class="state p-danger-o"><label>Yes</label></div>
                    </div>
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="holiday_entitlement" value="No" v-model="test.holiday_entitlement" disabled="disabled">
                      <div class="state p-success-o"><label>No</label></div>
                    </div>
                  </div>
                  <!-- Work Place Pension -->
                  <div class="col-xl-8 mb-2" :class="{ 'testIssue': testIssue('work_place_pension'), 'testFail': testFail('work_place_pension')}">
                    <p class="mb-0">
                      <span class="d-inline-block testIF" v-if="testFail('work_place_pension')">FAIL</span>
                      <span class="d-inline-block testIF" v-if="testIssue('work_place_pension')">ISSUE</span>
                      <span class="d-inline-block testQuestion">Work Place Pension</span>
                    </p>
                  </div>
                  <div class="col-xl-4">
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="work_place_pension" value="Yes" v-model="test.work_place_pension" disabled="disabled">
                      <div class="state p-danger-o"><label>Yes</label></div>
                    </div>
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="work_place_pension" value="No" v-model="test.work_place_pension" disabled="disabled">
                      <div class="state p-success-o"><label>No</label></div>
                    </div>
                  </div>
                  <!-- Maternity / Paternity -->
                  <div class="col-xl-8 mb-2" :class="{ 'testIssue': testIssue('maternity_paternity'), 'testFail': testFail('maternity_paternity')}">
                    <p class="mb-0">
                      <span class="d-inline-block testIF" v-if="testFail('maternity_paternity')">FAIL</span>
                      <span class="d-inline-block testIF" v-if="testIssue('maternity_paternity')">ISSUE</span>
                      <span class="d-inline-block testQuestion">Maternity / Paternity</span>
                    </p>
                  </div>
                  <div class="col-xl-4">
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="maternity_paternity" value="Yes" v-model="test.maternity_paternity" disabled="disabled">
                      <div class="state p-danger-o"><label>Yes</label></div>
                    </div>
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="maternity_paternity" value="No" v-model="test.maternity_paternity" disabled="disabled">
                      <div class="state p-success-o"><label>No</label></div>
                    </div>
                  </div>
                  <!-- Paid Training -->
                  <div class="col-xl-8 mb-2" :class="{ 'testIssue': testIssue('paid_training'), 'testFail': testFail('paid_training')}">
                    <p class="mb-0">
                      <span class="d-inline-block testIF" v-if="testFail('paid_training')">FAIL</span>
                      <span class="d-inline-block testIF" v-if="testIssue('paid_training')">ISSUE</span>
                      <span class="d-inline-block testQuestion">Paid training (this does not include any training on internal systems or procedures)</span>
                    </p>
                  </div>
                  <div class="col-xl-4">
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="paid_training" value="Yes" v-model="test.paid_training" disabled="disabled">
                      <div class="state p-danger-o"><label>Yes</label></div>
                    </div>
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="paid_training" value="No" v-model="test.paid_training" disabled="disabled">
                      <div class="state p-success-o"><label>No</label></div>
                    </div>
                  </div>
                </div>
              </b-card>
            </div>
            <!-- Section 6 - Business on own Account -->
            <div class="col-12">
              <b-card header="Section 6 - Business on own Account" header-tag="h4" body-class="mb-3 pb-2">
                <!-- Restrict other work -->
                <div class="row">
                  <div class="col-xl-8 mb-2" :class="{ 'testIssue': testIssue('restrict_other_work'), 'testFail': testFail('restrict_other_work')}">
                    <p class="mb-0">
                      <span class="d-inline-block testIF" v-if="testFail('restrict_other_work')">FAIL</span>
                      <span class="d-inline-block testIF" v-if="testIssue('restrict_other_work')">ISSUE</span>
                      <span class="d-inline-block testQuestion">Does your contract include any clauses that restrict you from performing paid work from another client during the
                        contract?</span>
                    </p>
                  </div>
                  <div class="col-xl-4">
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="restrictOtherWork" value="Yes" v-model="test.restrict_other_work" disabled="disabled">
                      <div class="state p-danger-o"><label>Yes</label></div>
                    </div>
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="restrict_other_work" value="No" v-model="test.restrict_other_work" disabled="disabled">
                      <div class="state p-success-o"><label>No</label></div>
                    </div>
                  </div>
                </div>
                <!-- Own money on training -->
                <div class="row">
                  <div class="col-xl-8 mb-2" :class="{ 'testIssue': testIssue('own_money_on_training'), 'testFail': testFail('own_money_on_training')}">
                    <p class="mb-0">
                      <span class="d-inline-block testIF" v-if="testFail('own_money_on_training')">FAIL</span>
                      <span class="d-inline-block testIF" v-if="testIssue('own_money_on_training')">ISSUE</span>
                      <span class="d-inline-block testQuestion">Have you spent money training yourself on skills which are used in your contracting career?</span>
                    </p>
                  </div>
                  <div class="col-xl-4">
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="own_money_on_training" value="Yes" v-model="test.own_money_on_training" disabled="disabled">
                      <div class="state p-success-o"><label>Yes</label></div>
                    </div>
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="own_money_on_training" value="No" v-model="test.own_money_on_training" disabled="disabled">
                      <div class="state p-danger-o"><label>No</label></div>
                    </div>
                  </div>
                </div>
              </b-card>
            </div>
            <!-- Section 7 - Equipment -->
            <div class="col-12">
              <b-card header="Section 7 - Equipment" header-tag="h4" body-class="mb-3 pb-2">
                <!-- Provide own equipment -->
                <div class="row">
                  <div class="col-xl-8 mb-2" :class="{ 'testIssue': testIssue('provide_own_equipment'), 'testFail': testFail('provide_own_equipment')}">
                    <p class="mb-0">
                      <span class="d-inline-block testIF" v-if="testFail('provide_own_equipment')">FAIL</span>
                      <span class="d-inline-block testIF" v-if="testIssue('provide_own_equipment')">ISSUE</span>
                      <span class="d-inline-block testQuestion">Are you required to provide, at your own cost your own equipment and/or materials that are significant and integral
                        to completing the project? (i.e. PPE, tools, power tools, plant, materials, vehicle)</span>
                    </p>
                  </div>
                  <div class="col-xl-4">
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="provide_own_equipment" value="Yes" v-model="test.provide_own_equipment" disabled="disabled">
                      <div class="state p-success-o"><label>Yes</label></div>
                    </div>
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="provide_own_equipment" value="No" v-model="test.provide_own_equipment" disabled="disabled">
                      <div class="state p-warning-o"><label>No</label></div>
                    </div>
                  </div>
                </div>
              </b-card>
            </div>
          </div>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "compliance_tests",
  props: ['worker', 'tests'],
  computed: {
    test() {
      if (this.notEmptyObject(this.tests)) {
        return this.tests[0];
      }
    }
  },
  data(){
    return{
      latest_compliance_test: {},
    }
  },  
  beforeMount(){
      // latest compliance test
      axios.get(this.crmApiPath + 'worker/compliance_test/worker/' + this.worker.id + '/latest').then(worker_compliance_test => {
      if (worker_compliance_test !== undefined && worker_compliance_test !== null) {
        this.latest_compliance_test = worker_compliance_test.data;
      }
      this.entity_test_loaded = true;
    }).catch(error => console.log(error.response));
  },
  methods: {
    new_entity_test() {
      this.$store.commit('CURRENT_NEW_ENTITY_TEST_WORKER_ID', this.worker.id);
      this.$nextTick(() => this.$router.push('/workers/entity_test/new'));
    },
    testIssue(question) {
      switch (question) {
        case "using_own_ltd_company" :
          if (this.test['using_own_ltd_company'] === "Don't Know") {
            return true
          }
          break;
        case "send_substitution" :
          if (this.test['send_substitution'] === "Don't Know") {
            return true
          }
          break;
        case "named_project" :
          if (this.test['named_project'] === "Don't Know") {
            return true
          }
          break;
        case "decide_working_hours" :
          if (this.test['decide_working_hours'] === "Partly") {
            return true
          }
          break;
        case "offer_other_work" :
          if (this.test['offer_other_work'] === "Don't Know") {
            return true
          }
          break;
        case "correct_errors" :
          if (this.test['correct_errors'] === "Don't Know") {
            return true
          }
          break;
        case "provide_own_equipment" :
          if (this.test['provide_own_equipment'] === "No") {
            return true
          }
          break;
        default :
          break;
      }
    },
    testFail(question) {
      switch (question) {
        case "using_own_ltd_company" :
          if (this.test['using_own_ltd_company'] === "No" || this.test['using_own_ltd_company'] == null) {
            return true
          }
          break;
        case "uk_tax_payer" :
          if (this.test['uk_tax_payer'] === "No" || this.test['uk_tax_payer'] == null) {
            return true
          }
          break;
        case "send_substitution" :
          if (this.test['send_substitution'] === "No" || this.test['send_substitution'] == null) {
            return true
          }
          break;
        case "s_d_c" :
          if (this.test['s_d_c'] === "Yes" || this.test['s_d_c'] === null) {
            return true
          }
          break;
        case "switch_projects" :
          if (this.test['switch_projects'] === "Yes" || this.test['switch_projects'] === null) {
            return true
          }
          break;
        case "named_project" :
          if (this.test['named_project'] === "No" || this.test['named_project'] === null) {
            return true
          }
          break;
        case "how_work_performed" :
          if (this.test['how_work_performed'] === "No" || this.test['how_work_performed'] === null) {
            return true
          }
          break;
        case "decide_working_hours" :
          if (this.test['decide_working_hours'] === "Yes" || this.test['decide_working_hours'] === null) {
            return true
          }
          break;
        case "notice_period" :
          if (this.test['notice_period'] === "7 Days" || this.test['notice_period'] === "Longer" || this.test['notice_period'] === null) {
            return true
          }
          break;
        case "offer_other_work" :
          if (this.test['offer_other_work'] === "Yes" || this.test['offer_other_work'] === null) {
            return true
          }
          break;
        case "correct_errors" :
          if (this.test['correct_errors'] === "No" || this.test['correct_errors'] === null) {
            return true
          }
          break;
        case "last_permanent_employer" :
          if (this.test['last_permanent_employer'] === "Yes" || this.test['last_permanent_employer'] === null) {
            return true
          }
          break;
        case "sick_pay" :
          if (this.test['sick_pay'] === "Yes" || this.test['sick_pay'] === null) {
            return true
          }
          break;
        case "holiday_entitlement" :
          if (this.test['holiday_entitlement'] === "Yes" || this.test['holiday_entitlement'] === null) {
            return true
          }
          break;
        case "work_place_pension" :
          if (this.test['work_place_pension'] === "Yes" || this.test['work_place_pension'] === null) {
            return true
          }
          break;
        case "maternity_paternity" :
          if (this.test['maternity_paternity'] === "Yes" || this.test['maternity_paternity'] === null) {
            return true
          }
          break;
        case "paid_training" :
          if (this.test['paid_training'] === "Yes" || this.test['paid_training'] === null) {
            return true
          }
          break;
        case "restrict_other_work" :
          if (this.test['restrict_other_work'] === "Yes" || this.test['restrict_other_work'] === null) {
            return true
          }
          break;
        case "own_money_on_training" :
          if (this.test['own_money_on_training'] === "No" || this.test['own_money_on_training'] === null) {
            return true
          }
          break;
        default :
          break;
      }
    },
    edit_test() {
      this.$store.commit('CURRENT_EDIT_ENTITY_TEST_ID', this.test.id);
      // Close current tab and open up profile worker
      this.$nextTick(() => {
        this.$tabs.close({
          path: this.$router.currentRoute.fullPath,
          to: '/workers/entity_test/edit'
        });
      })
    },
    check_test_expiry() {
      let now = this.$moment().format('YYYY-MM-DD');
      return this.$moment(now).isAfter(this.$moment(this.latest_compliance_test.test_expiry));
    },
  }
}
</script>

<style scoped lang="scss">
#no_tests {
  min-height: calc(100vh - 200px) !important;

  .container {
    max-width: 380px;
  }
}

.test_status {
  &.Fail, &.Amber, &.Pass {
    text-align:     center;
    font-size:      2rem;
    text-transform: uppercase;
    font-weight:    bold;
    color:          $white;
    border-radius:  $border_radius_2;
  }

  &.Fail {
    background: $red;
  }

  &.Amber {
    background: $orange;
  }

  &.Pass {
    background: $green;
  }
}

p {
  padding-top: 0 !important;
}

/* PRETTY CHECKBOX MULTI LINE */
.pretty {
  white-space:   inherit;
  margin-bottom: 0.5em;

  .state {
    label {
      text-indent:  0;
      padding-left: 2rem;
      line-height:  1;

      &:after, &:before {
        top: 0;
      }
    }
  }
}

.testFail {
  background:     rgba($red, 0.5);
  padding-top:    10px;
  padding-bottom: 10px;
}

.testIssue {
  background:     rgba($orange, 0.5);
  padding-top:    10px;
  padding-bottom: 10px;
}

.testIF {
  color:          #ffffff;
  border:         2px solid #ffffff;
  border-radius:  3px;
  width:          60px;
  line-height:    34px;
  font-weight:    bold;
  text-align:     center;
  font-size:      1rem;
  margin-right:   10px;
  vertical-align: top;
}

.testQuestion {
  width: -webkit-calc(100% - 75px);
  width: -moz-calc(100% - 75px);
  width: calc(100% - 75px);
}
</style>
